import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "field"]

  connect() {
    if (this.hasFieldTarget && this.fieldTarget.value) {
      this.selectedValue = this.fieldTarget.value
    }
    this.updateSelection()
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    this.selectedValue = value

    if (value === "unsure") {
      this.fieldTarget.value = ""
      this.fieldTarget.dataset.paoUnsure = "true"
    } else {
      this.fieldTarget.value = value
      delete this.fieldTarget.dataset.paoUnsure
    }

    this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.updateSelection()
  }

  fieldChanged() {
    this.selectedValue = this.fieldTarget.dataset.paoUnsure === "true" ? "unsure" : this.fieldTarget.value
    this.updateSelection()
  }

  updateSelection() {
    this.optionTargets.forEach(option => {
      const optionValue = option.dataset.value

      if (this.selectedValue && optionValue === this.selectedValue) {
        option.classList.add("border-warm-gray-800", "ring-1", "ring-warm-gray-800")
        option.classList.remove("border-warm-gray-300", "hover:bg-warm-gray-50")
      } else {
        option.classList.remove("border-warm-gray-800", "ring-1", "ring-warm-gray-800")
        option.classList.add("border-warm-gray-300", "hover:bg-warm-gray-50")
      }
    })
  }
}
